<template>
    <div class="i-standarts__container">
        <div class="i-standarts__desc-wrapper">
            <div
                class="i-standarts__desc-wrap"
                ref="descWrap">
                <p
                    class="i-standarts__desc i-standarts__desc--disabled"
                    v-html="description"></p>
            </div>
            <button
                v-if="!showAllDescription"
                class="i-standarts__show-more"
                @click.prevent="showMore">Показать еще</button>
        </div>
    </div>
    <section
        v-if="investorsDataIsLoading || investorsData"
        class="i-standarts__wrapper">
        <loader v-if="investorsDataIsLoading" />
        <template v-if="investorsData">
            <div
                v-for="(item, i) in investorsData.data"
                :key="i"
                class="i-standarts__wrap">
                <chart
                    :chart-data="item"
                    :id="i" />
            </div>
        </template>
    </section>
</template>

<script>
    import Loader from '../vue-components/Loader'
    import Chart from './components/Chart'
    import { investorsDataActionTypes } from '../store/modules/investors/investors'
    import { mapState } from 'vuex'

    export default {
        name: 'Standarts',
        components: {
            Loader,
            Chart
        },
        data() {
            return {
                apiUrl: '/api/v2/content/investors/regulations/',
                showAllDescription: false,
                description: 'Единый институт развития в жилищной сфере обязан соблюдать нормативы финансовой устойчивости во исполнение статьи 5.1 Федерального закона № 225-ФЗ в соответствии с методиками, установленными Постановлением Правительства Российской Федерации № 1680. Единый институт развития в жилищной сфере рассчитывает нормативы финансовой устойчивости ежеквартально на дату составления годовой и промежуточной консолидированной финансовой отчётности.<br><br>По итогам рассмотрения Национальным советом по обеспечению финансовой стабильности результатов стресс-тестирования достаточности собственных средств (капитала) и стресс-тестирования достаточности своих ликвидных активов, проводимых в соответствии с методиками, установленными Постановлением Правительства Российской Федерации № 1680, во исполнение статьи 5.1 Федерального закона № 225-ФЗ, требования к достаточности собственных средств (капитала) и ликвидных активов не нарушаются, план обеспечения финансовой устойчивости единого института развития в жилищной сфере не реализуется.'
            }
        },
        computed: {
            ...mapState({
                investorsDataIsLoading: state => state.investorsData.isLoading,
                investorsData: state => state.investorsData.data,
                investorsDataError: state => state.investorsData.error,
            }),
        },

        methods: {
            showMore () {
                this.$refs.descWrap.querySelector('.i-standarts__desc').classList.remove('i-standarts__desc--disabled')
                this.showAllDescription = true
                this.$nextTick(() => {
                    this.$refs.descWrap.style.height = `${this.$refs.descWrap.scrollHeight}px`
                })
            }
        },
        created() {
            this.$nextTick(() => {
                this.$refs.descWrap.style.height = `${this.$refs.descWrap.scrollHeight}px`
            })
            this.$store.dispatch(investorsDataActionTypes.getInvestorsData, {apiUrl: this.apiUrl})
        },
    }
</script>